import { Check, X, Clock } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ApprovalStepDTO } from '@employer-on-record/shared';

interface Props {
	approvals: ApprovalStepDTO[];
	currentLevel: number;
	className?: string;
}

export function ApprovalProgress({ approvals, currentLevel, className }: Props) {
	const sorted = [...approvals].sort((a, b) => a.level - b.level);
	return (
		<div className={cn('inline-flex items-center gap-1.5', className)}>
			{sorted.map((step, i) => {
				const isCurrent = step.status === 'pending' && step.level === currentLevel;
				const Icon = step.status === 'approved' ? Check : step.status === 'rejected' ? X : Clock;
				const dotClass =
					step.status === 'approved' ? 'bg-success text-white' :
					step.status === 'rejected' ? 'bg-destructive text-white' :
					isCurrent ? 'bg-warning text-white' :
					'bg-background text-muted-foreground border';
				return (
					<span key={step.id} className="inline-flex items-center gap-1.5">
						<span
							className={cn('h-5 w-5 rounded-full grid place-items-center text-[10px] font-semibold', dotClass)}
							title={`L${step.level} · ${step.approverName ?? 'unassigned'} · ${step.status}`}
						>
							<Icon className="h-3 w-3" />
						</span>
						{i < sorted.length - 1 && <span className="h-px w-3 bg-border" />}
					</span>
				);
			})}
		</div>
	);
}
